import React, { PureComponent } from 'react';
import { observer } from 'mobx-react';
import dshStore from '../request/model';
import { getEngineerData } from '../request/dao';
import './index.styl';
import picObj from './picture/index';

import Zmage from 'react-zmage';

const clzpre = 'dsh-engineering';

@observer
class Engineering extends PureComponent {
    constructor(props) {
        super(props);
        this.testdata = [
            {
                id: '',
                url: picObj.pic1,
                type: 'picture',
                extra: {
                    title: '',
                    description: ''
                }
            },
            {
                id: '',
                url: picObj.pic1,
                type: 'picture',
                extra: {
                    title: '',
                    description: ''
                }
            },
            {
                id: '',
                url: picObj.pic1,
                type: 'picture',
                extra: {
                    title: '',
                    description: ''
                }
            },
            {
                url: picObj.pic2,
                type: 'picture'
            },
            {
                url: picObj.pic3,
                type: 'picture'
            },
            {
                url: picObj.pic4,
                type: 'picture'
            }
        ];
    }

    componentDidMount() {
        getEngineerData();
    }

    generatePictureArea = () => {
        const { engineerings } = this.props.dshStore;
        return (engineerings || []).map((item, index) => {
            const url = item.urls || [];
            if (url[0]) {
                return <Zmage edge={100} backdrop="#080935" src={url[0]} alt="地址无效" key={`${url[0]}${index}`} />;
            } else {
                return '';
            }
        });
    };

    render() {
        return (
            <div className={`${clzpre} dsh-box`}>
                <h3>工程管理信息</h3>
                <div className={`${clzpre}-area`}>{this.generatePictureArea()}</div>
            </div>
        );
    }
}

export default props => <Engineering dshStore={dshStore} {...props} />;
